import React from "react";

import {
  FaExclamationTriangle,
  FaTimes,
  FaTrashAlt,
} from "react-icons/fa";

function getElementLabel(
  confirmation
) {
  const data =
    confirmation?.data;

  return (
    data?.titre ||
    data?.label ||
    data?.question ||
    data?.alt_text ||
    data?.url ||
    `Élément #${data?.id}`
  );
}

export default function ConfirmContentDialog({
  confirmation,
  loading,
  onClose,
  onConfirm,
}) {
  if (!confirmation) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-[1450] flex items-center justify-center p-4">
      <button
        type="button"
        className="absolute inset-0 bg-slate-950/75 backdrop-blur-sm"
        onClick={
          loading
            ? undefined
            : onClose
        }
        aria-label="Fermer"
      />

      <div className="relative w-full max-w-lg overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-[0_35px_100px_-30px_rgba(0,0,0,0.60)] dark:border-slate-800 dark:bg-slate-900">
        <div className="p-6">
          <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-rose-100 text-xl text-rose-700 dark:bg-rose-500/15 dark:text-rose-300">
            <FaExclamationTriangle />
          </div>

          <h3 className="mt-5 text-xl font-semibold text-slate-900 dark:text-slate-50">
            {confirmation.title}
          </h3>

          <p className="mt-2 text-sm leading-6 text-slate-500 dark:text-slate-400">
            {confirmation.description}
          </p>

          <div className="mt-4 break-words rounded-2xl bg-slate-100 px-4 py-3 font-semibold text-slate-900 dark:bg-slate-800 dark:text-slate-50">
            {getElementLabel(
              confirmation
            )}
          </div>
        </div>

        <div className="flex flex-col-reverse gap-3 border-t border-slate-200 bg-slate-50 px-6 py-4 dark:border-slate-800 dark:bg-slate-950/50 sm:flex-row sm:justify-end">
          <button
            type="button"
            disabled={loading}
            onClick={onClose}
            className="inline-flex items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-2.5 text-sm font-medium text-slate-700 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200"
          >
            <FaTimes />
            Annuler
          </button>

          <button
            type="button"
            disabled={loading}
            onClick={onConfirm}
            className="inline-flex items-center justify-center gap-2 rounded-2xl bg-rose-600 px-4 py-2.5 text-sm font-medium text-white transition hover:bg-rose-700 disabled:opacity-50"
          >
            <FaTrashAlt />

            {loading
              ? "Suppression..."
              : confirmation.confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}